import React, { useEffect, useState } from 'react';
import { Button } from './Button';
import { CalendarIcon } from 'lucide-react';
export const ProgressBar = () => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight - windowHeight;
      const scrolled = window.scrollY;
      const progress = scrolled / documentHeight * 100;
      setProgress(progress);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="fixed bottom-0 left-0 right-0 bg-[#231232]/95 backdrop-blur-md border-t border-[#6805DA]/20 py-4 z-50 shadow-xl" data-id="element-358" data-mp="3r6y1a1lhi1qg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-359" data-mp="16ffiwi5gsbtz">
        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-8" data-id="element-360" data-mp="16dkugtuzi1l5">
          <div className="w-full sm:flex-1" data-id="element-361" data-mp="11fjc6b5du6aq">
            <div className="h-2 bg-[#6805DA]/20 rounded-full" data-id="element-362" data-mp="ovvd6a51wh0a">
              <div className="h-full bg-gradient-to-r from-[#6805DA] to-[#4B0599] rounded-full transition-all duration-300" style={{
              width: `${progress}%`
            }} data-id="element-363" data-mp="ovbrcica58gz" />
            </div>
          </div>
          <Button variant="gradient-primary" size="md" className="w-full sm:w-auto whitespace-nowrap font-medium" href="/start" data-id="element-364" data-mp="13s2v13szl6ce">
            <CalendarIcon className="mr-2" size={16} data-id="element-365" data-mp="b3niqp18p24r" /> Schedule a Consultation
          </Button>
        </div>
      </div>
    </div>;
};